"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailDocumentContainer = exports.AssetDetailDocumentIconContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AssetDetailDocumentIconContainer = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	gap: 2rem;
`;
exports.AssetDetailDocumentContainer = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	border: 2px solid ${props => props.theme.color.gray9};
`;
